// src/components/SocialCalendarTool.js
import React from 'react';
import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import calendarImage from '../assets/images/Calender.png'; // Using an existing asset as the visual

const features = [
  "Visualize your entire content strategy at a glance.",
  "Drag-and-drop posts to easily reschedule.",
  "AI-powered suggestions for the best times to post.",
  "Collaborate with your team with comments and approvals.",
  "Filter by platform, campaign, or content status."
];

const SocialCalendarTool = () => {
  return (
    <div className="mx-auto max-w-7xl px-6">
      <div className="bg-dark-card/40 backdrop-blur-lg border border-white/10 rounded-3xl p-8">
        {/* Mockup of the app window */}
        <div className="bg-dark-card/60 rounded-t-xl p-3 border-b border-white/10 flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-red-500"></div>
          <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
          <div className="w-3 h-3 rounded-full bg-green-500"></div>
        </div>
        <div className="aspect-video">
          <img src={calendarImage} alt="Oolook Social Calendar" className="w-full h-full object-cover" />
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
          <div>
            <h3 className="text-xl font-bold text-dark-text-primary">Your Command Center</h3>
            <p className="mt-2 text-dark-text-secondary">
              Stop the spreadsheet chaos. Oolook's visual calendar brings clarity to your content strategy, allowing you to plan, collaborate, and publish with confidence. See everything, everywhere, all in one place.
            </p>
          </div>
          <ul className="space-y-3">
            {features.map((feature, index) => (
              <li key={index} className="flex items-start gap-3">
                <IoCheckmarkCircleOutline className="h-5 w-5 mt-1 flex-none text-dark-accent-start" />
                <span className="text-dark-text-secondary">{feature}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SocialCalendarTool;